module.exports = __webpack_public_path__ + "static/media/uoa-6.fc7a1048.jpg";